<template>
    <a :href="social.url" target="_blank" rel="noopener noreferrer">
        <v-icon>
            {{ social.icon }}
        </v-icon>
    </a>
</template>

<script>
export default {
    name: 'SocialList',
    props: ['social'],
}
</script>